import React, { useRef, useEffect, useState } from 'react'

import { useStyles } from './HorizontalCardsSlider_style'
import { Box, IconButton, Typography, Hidden } from '@material-ui/core'
import IconFactory from '../../icons/IconFactory/IconFactory'

const HorizontalCardsSlider = (props) => {
    const classes = useStyles()
    const { children, shift, title, wrappedArrows, parentSliderRef } = props
    const sliderRef = parentSliderRef || useRef()
    const [showArrows, setShowArrows] = useState(false)
    const [canScrollLeft, setCanScrollLeft] = useState(false)
    const [canScrollRight, setCanScrollRight] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            const node = sliderRef.current
            if (!node) return
            const childWidth = node.firstChild?.offsetWidth || 0
            const sliderWidth = node.offsetWidth
            const childCount = node.childElementCount
            const needsScrolling = childCount && childWidth * childCount > sliderWidth
            setShowArrows(needsScrolling)
            updateScrollState()
        }, 200)
    }, [children])

    useEffect(() => {
        const node = sliderRef.current
        if (!node) return
        const onScroll = () => updateScrollState()
        node.addEventListener('scroll', onScroll)
        return () => node.removeEventListener('scroll', onScroll)
    }, [])

    const updateScrollState = () => {
        const node = sliderRef.current
        if (!node) return
        const { scrollLeft, scrollWidth, clientWidth } = node
        setCanScrollLeft(scrollLeft > 0)
        setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1)
    }

    const slide = (distance) => {
        sliderRef.current.scrollLeft += distance
    }

    const renderArrows = () => (
        <Box className={classes.buttonsContainer}>
            <Box>
                {canScrollLeft && (
                    <IconButton
                        onClick={() => slide(-shift)}
                        className={classes.button}
                    >
                        <IconFactory
                            className={classes.icon}
                            color='black'
                            icon='left-regular'
                        />
                    </IconButton>
                )}
            </Box>
            <Box>
                {canScrollRight && (
                    <IconButton
                        onClick={() => slide(shift)}
                        className={`${classes.button} ${classes.buttonActive}`}
                    >
                        <IconFactory
                            className={`${classes.icon} ${classes.iconActive}`}
                            color='white'
                            icon='right-regular'
                        />
                    </IconButton>
                )}
            </Box>
        </Box>
    )

    const renderWrappedArrows = () => (
        <Box className={classes.buttonWrappedPosition}>
            <Box className={classes.buttonsWrappedContainer}>
                <Box>
                    {canScrollLeft && (
                        <IconButton
                            onClick={() => slide(-shift)}
                            className={`${classes.button} ${classes.buttonActive}`}
                        >
                            <IconFactory
                                color='white'
                                className={`${classes.icon} ${classes.iconActive}`}
                                icon='left-regular'
                            />
                        </IconButton>
                    )}
                </Box>
                <Box>
                    {canScrollRight && (
                        <IconButton
                            onClick={() => slide(shift)}
                            className={`${classes.button} ${classes.buttonActive}`}
                        >
                            <IconFactory
                                color='white'
                                className={`${classes.icon} ${classes.iconActive}`}
                                icon='right-regular'
                            />
                        </IconButton>
                    )}
                </Box>
            </Box>
        </Box>
    )

    return (
        <Box className={classes.sliderContainer}>
            {title && (
                <Box className={classes.titleContainer}>
                    <Typography
                        className={classes.title}
                        variant="h1"
                        component="h2"
                    >
                        {title}
                    </Typography>
                    <Hidden mdDown>
                        {showArrows && renderArrows()}
                    </Hidden>
                </Box>
            )}

            {wrappedArrows && showArrows && (
                <Hidden xsDown>
                    {renderWrappedArrows()}
                </Hidden>
            )}

            <Box
                className={`${classes.cardsContainer} ${
                    wrappedArrows && showArrows ? classes.cardContainerWrapped : ''
                }`}
                ref={sliderRef}
            >
                {children}
            </Box>
        </Box>
    )
}

export default HorizontalCardsSlider
